<template>
    <div>
        <confirm-dialog @confirmed="remove" @canceled="remove(true)">
            <button-delete><i class="fa fa-trash"></i></button-delete>
            <template v-slot:header>Buchung löschen</template>
            <template v-slot:question>
                <span v-show="!booking.conference_room_booking_series_id || (booking.conference_room_booking_series_id && new Date(booking.start) < (new Date()).setHours(0,0,0,0))"> Soll die Buchung für
                    <span class="font-bold">{{ booking.start | date }}</span>
                    wirklich gelöscht werden?
                </span>
                <span v-show="booking.conference_room_booking_series_id && new Date(booking.start) >= (new Date()).setHours(0,0,0,0)"> Die ausgewählte Buchung für den <span
                    class="font-bold">{{ booking.start | date }}</span> ist Teil einer Serienbuchung. Möchten Sie nur die Buchung für den <span
                    class="font-bold">{{ booking.start | date }}</span> löschen, oder die gesamte Serie ab Heute?</span>
            </template>
            <template v-slot:confirm class="">
                Buchung löschen
            </template>
            <template v-slot:cancel v-if="booking.conference_room_booking_series_id && new Date(booking.start) >= (new Date()).setHours(0,0,0,0)" @click="remove(booking,true)">
                Serie löschen
            </template>
        </confirm-dialog>
    </div>
</template>

<script>
import Modal from "./Modal";
import Loading from "./UI/Loading";
import ConfirmDialog from "./UI/ConfirmDialog.vue";
import ButtonDelete from "./UI/ButtonDelete.vue";

export default {
    name: "ConferenceRoomBookingDelete",
    components: {
        ButtonDelete,
        ConfirmDialog,
        Loading,
        Modal,
    },

    inject: ['group'],

    data: () => ({
        showModal: false,
        loading: false,
    }),

    props: {
        booking: {},
    },

    filters: {
        date(val) {
            let [date, time] = val.split(' ');
            let [y, m, d] = date.split('-');
            return `${d}.${m}.${y}`;
        }
    },

    methods: {
        remove(deleteSeries = false) {
            this.loading = true;
            this.$http
                .post(`/admin/conference_room_bookings/${this.booking.id}`, {
                    params: {
                        deleteSeries: deleteSeries
                    },
                    _method: 'delete',
                })
                .then(() => {
                    this.$emit('deleted');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    }

}
</script>

<style scoped>

</style>
